// On Create Product form if add new tax/fee is clicked
export function addtaxfeefields() {
  const showTaxFeeFieldsLink = document.getElementById('showTaxFeeFields');
  const taxFeeCreationFields = document.getElementById('taxFeeCreationFields');
  const taxFeeForm = document.getElementById('taxFeeForm');

  // Check if all elements exist
  if (showTaxFeeFieldsLink && taxFeeCreationFields && taxFeeForm) {
    showTaxFeeFieldsLink.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('showTaxFeeFields link clicked');

      if (!taxFeeCreationFields.contains(taxFeeForm)) {
        taxFeeCreationFields.appendChild(taxFeeForm);
        taxFeeForm.style.display = 'block';
      } else {
        document.body.appendChild(taxFeeForm); // Or append to another container if you prefer
        taxFeeForm.style.display = 'none';
      }
    });
  }
}

export function addTaxFee() {
  // Get form data
  const formData = new FormData(document.getElementById('taxFeeForm'));

  // Send POST request
  fetch('/payments/add_taxfee/', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest', // For Django to treat this as AJAX
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Server Response:', data); // Debugging Log

      if (data.status === 'success') {
        // Add the new TaxFee to the select options
        const select = document.getElementById('id_tax_fees');

        // Remove the placeholder option
        const placeholderOption = select.querySelector(
          'option[name="placeholder"]',
        );
        if (placeholderOption) {
          select.removeChild(placeholderOption);
        }

        const option = document.createElement('option');
        option.value = data.taxfee_id;
        option.textContent = data.taxfee_name;
        option.selected = true;
        select.appendChild(option);

        console.log('Adding new Tax/Fee was successful!'); // Debugging Log

        // Hide the form
        const taxFeeForm = document.getElementById('taxFeeForm');
        if (taxFeeForm) {
          taxFeeForm.style.display = 'none';
          // Reset the form fields
          taxFeeForm.reset();
          console.log('Form should be hidden and reset now.'); // Debugging Log
        } else {
          console.error("Couldn't find the TaxFeeForm"); // Debugging Log
        }
      } else {
        // Handle errors (maybe show them on the page)
        console.error(data.errors);
      }
    });
}
